import { bindContractSummary } from './bindData';

export const getContractSummary = (
  totalDiscount,
  totalPrice,
  translate,
  paymentFrequency,
  isFetchingPrice,
  insuredPeople,
  classes,
  language,
  handleOpenInsuredPeopleModal,
) => bindContractSummary(
  totalDiscount,
  totalPrice,
  translate,
  paymentFrequency,
  isFetchingPrice,
  insuredPeople,
  classes,
  language,
  handleOpenInsuredPeopleModal,
);
